var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "id": _vm.modalId,
      "title": _vm.pacote ? _vm.pacote.titulo : 'Novidades do Sistema',
      "size": "lg",
      "centered": "",
      "scrollable": "",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_vm.pacote ? _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-4"
  }, [_c('span', {
    staticStyle: {
      "font-size": "32px",
      "line-height": "1",
      "margin-right": "12px"
    }
  }, [_vm._v("🚀")]), _c('div', [_vm.pacote.descricao_curta ? _c('p', {
    staticClass: "text-muted mb-1"
  }, [_vm._v(" " + _vm._s(_vm.pacote.descricao_curta) + " ")]) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "gap": "8px"
    }
  }, [_vm.pacote.versao ? _c('span', {
    staticClass: "label label-inline label-light-primary font-weight-bold"
  }, [_vm._v(" Versão " + _vm._s(_vm.pacote.versao) + " ")]) : _vm._e(), _vm.pacote.data_publicacao ? _c('span', {
    staticClass: "label label-inline label-primary font-weight-bold"
  }, [_vm._v(" 📅 " + _vm._s(_vm.$moment(_vm.pacote.data_publicacao).format('DD/MM/YYYY')) + " ")]) : _vm._e(), _vm.pacote.itens && _vm.pacote.itens.length ? _c('span', {
    staticClass: "label label-inline label-light-success font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.pacote.itens.length) + " " + _vm._s(_vm.pacote.itens.length === 1 ? "novidade" : "novidades") + " ")]) : _vm._e()])])]), _c('hr', {
    staticClass: "mb-5"
  }), _vm._l(_vm.pacote.itens, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex mb-6"
    }, [_c('div', {
      staticClass: "mr-4 mt-1"
    }, [_c('span', {
      staticClass: "label label-xl label-inline font-weight-bold",
      class: _vm.tipoBadgeClass(item.tipo),
      staticStyle: {
        "min-width": "110px"
      }
    }, [_vm._v(" " + _vm._s(_vm.tipoLabel(item.tipo)) + " ")])]), _c('div', {
      staticClass: "flex-grow-1"
    }, [_c('h6', {
      staticClass: "font-weight-bolder text-dark mb-1"
    }, [_vm._v(_vm._s(item.titulo))]), item.descricao_curta ? _c('p', {
      staticClass: "text-muted font-size-sm mb-2"
    }, [_vm._v(" " + _vm._s(item.descricao_curta) + " ")]) : _vm._e(), item.video_url || item.documentacao_url ? _c('div', {
      staticClass: "d-flex flex-wrap",
      staticStyle: {
        "gap": "8px"
      }
    }, [item.video_url ? _c('a', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "href": item.video_url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" ▶ Ver vídeo ")]) : _vm._e(), item.documentacao_url ? _c('a', {
      staticClass: "btn btn-sm btn-light-info font-weight-bold",
      attrs: {
        "href": item.documentacao_url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" 📄 Documentação ")]) : _vm._e()]) : _vm._e()])]);
  }), _c('hr', {
    staticClass: "mt-4 mb-5"
  }), _c('div', {
    staticClass: "d-flex justify-content-end",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold",
    on: {
      "click": _vm.verDepois
    }
  }, [_vm._v(" Ver depois ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bolder",
    attrs: {
      "disabled": _vm.marcando
    },
    on: {
      "click": _vm.marcarComoLido
    }
  }, [_vm.marcando ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Entendi (Não apresentar novamente) ")], 1)])], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };